import HomePage from "./pages/home/Home.page";

export const marketingRoutes = [
    {
        index: true,
        Component: () => <HomePage />
    }
]